import { defineMessages, FormattedMessage } from 'react-intl';

import { getLinkAriaLabel } from '@/utils/urlUtils';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { paths } from '@/lib/paths';
import { commonMessages as termsCommonMessages } from '@/messages/common';

export const commonMessages = defineMessages({
  tellUsSomething: {
    id: 'appointment.tellUsSomething',
    defaultMessage: 'Tell us something....',
  },
  bookAppointment: {
    defaultMessage: 'Book an appointment',
    id: 'bookAppointment',
  },
  viewBoutiqueDetail: {
    defaultMessage: 'View Boutique Details',
    id: 'boutique.viewBoutiqueDetails',
  },
  personalAdvice: {
    defaultMessage:
      'Book your appointment in one of our Breitling Boutique to try on your favourite watches and receive personalized advice. Our appointment can also be organized virtually.',
    id: 'appointment.personalAdvice',
  },
  chooseRetailer: {
    defaultMessage: 'CHOOSE YOUR RETAILER',
    id: 'appointment.chooseRetailer',
  },
  appointmentDate: {
    defaultMessage: 'On which day would you like your appointment?',
    id: 'appointment.appointmentDate',
  },
  storeText: {
    defaultMessage: 'Store*',
    id: 'appointment.storeText',
  },
  timeSlotText: {
    defaultMessage: 'Select an available time slot:',
    id: 'appointment.timeSlotText',
  },
  personalInfo: {
    defaultMessage: 'PERSONAL INFORMATION',
    id: 'appointment.personalInfo',
  },

  bookAppointmentTo: {
    defaultMessage: 'I WOULD LIKE TO BOOK AN APPOINTMENT TO:',
    id: 'appointment.bookAppointmentTo',
  },
  legalText: {
    // eslint-disable-next-line
    defaultMessage: `I would like to be kept informed by Breitling SA about offers and events related to Breitling products by email, telephone and SMS. You can revoke this consent at any time by sending a message to <a href="#">dataprivacy@breitling.com</a> or by clicking the "unsubscribe" button in out marketing emails.<br></br> By clicking "Book an appointment", you confirm you have read the Breitling <a href="https://www.breitling.com/us-en/privacy-policy/">Privacy Policy</a> and have read and accepted <a href="https://www.breitling.com/us-en/terms-of-use/">Breitling terms of use.</a>`,
    id: 'appointment.legalText',
  },
  discoverCollections: {
    defaultMessage: 'DISCOVER THE COLLECTIONS',
    id: 'appointment.discoverCollections',
  },
  gratitudeText: {
    defaultMessage: 'Thank you for booking an appointment on Breitling.com',
    id: 'appointment.gratitudeText',
  },
  retailerInTouch: {
    defaultMessage:
      'Your retailer will be in touch to confirm your appointment',
    id: 'appointment.retailerInTouch',
  },
  contactBoutiqueText: {
    defaultMessage:
      'For same day appointments, please contact the boutique directly by phone.',
    id: 'appointment.contactBoutiqueText',
  },
  validAppointmentText: {
    defaultMessage:
      'The request is valid once the appointment has been confirmed by your selected boutique in the next step.',
    id: 'appointment.validAppointmentText',
  },
  requirePhone: {
    defaultMessage: 'Phone number is required',
    id: 'appointment.requirePhone',
  },
  requirePhonePrefix: {
    defaultMessage: 'Phone prefix is required',
    id: 'appointment.requirePhonePrefix',
  },
  maxCharMsg: {
    defaultMessage: '50 characters maximum.',
    id: 'appointment.maxCharMsg',
  },
  maxPhoneCharMsg: {
    defaultMessage: '20 characters maximum.',
    id: 'appointment.maxPhoneCharMsg',
  },
  maxCommentsMsg: {
    defaultMessage: '3000 characters maximum.',
    id: 'appointment.maxCommentsMsg',
  },
  requireFirstName: {
    defaultMessage: 'First Name is required',
    id: 'appointment.requireFirstName',
  },
  requireLastName: {
    defaultMessage: 'Last Name is required',
    id: 'appointment.requireLastName',
  },
  requireEmail: {
    defaultMessage: 'Email is required',
    id: 'appointment.requireEmail',
  },
  invalidEmail: {
    defaultMessage: 'Invalid email address.',
    id: 'appointment.invalidEmail',
  },
  requireField: {
    defaultMessage: 'This field is required',
    id: 'appointment.requireField',
  },
  requireRetailer: {
    defaultMessage: 'Retailer is required',
    id: 'appointment.requireRetailer',
  },
  changeStoreButtonText: {
    defaultMessage: 'Change store',
    id: 'appointment.changeStoreButtonText',
  },
  boutiquesWithWatch: {
    defaultMessage:
      'Here are the boutiques where the watch is available. Please select with which one you want to book your appointment.',
    id: 'appointment.boutiquesWithWatch',
  },
  boutiquesWithSunglasses: {
    defaultMessage:
      'Here are the boutiques where the sunglasses are available. Please select with which one you want to book your appointment.',
    id: 'appointment.boutiquesWithSunglasses',
  },
  selectRegionPlaceholder: {
    defaultMessage: 'Select a region',
    id: 'appointment.selectRegionPlaceholder',
  },
  selectCityPlaceholder: {
    defaultMessage: 'Select a city',
    id: 'appointment.selectCityPlaceholder',
  },
  selectBoutiquePlaceholder: {
    defaultMessage: 'Select a boutique',
    id: 'appointment.selectBoutiquePlaceholder',
  },
  firstNamePlaceHolder: {
    defaultMessage: 'First name',
    id: 'appointment.firstNamePlaceHolder',
  },
  lastNamePlaceHolder: {
    defaultMessage: 'Last name',
    id: 'appointment.lastNamePlaceHolder',
  },
  emailPlaceHolder: {
    defaultMessage: 'Email',
    id: 'appointment.emailPlaceHolder',
  },
  phonePlaceHolder: {
    defaultMessage: 'Telephone Number',
    id: 'appointment.phonePlaceHolder',
  },
  reasonPlaceHolder: {
    defaultMessage: 'Select a reason',
    id: 'appointment.reasonPlaceHolder',
  },
  discover_and_try: {
    defaultMessage: 'Discover and try on the Breitling collection',
    id: 'appointment.discoverAndTry',
  },
  find_a_new_strap: {
    defaultMessage: 'Find a new strap for my Breitling',
    id: 'appointment.findANewStrap',
  },
  take_care_of_my_breitling: {
    defaultMessage: 'Take care of my Breitling(After Sales Service)',
    id: 'appointment.takeCareOfMyBreitling',
  },
  afterSales: {
    defaultMessage: 'AfterSales',
    id: 'appointment.afterSales',
  },
  information: {
    defaultMessage: 'Information',
    id: 'appointment.information',
  },
  purchase: {
    defaultMessage: 'Purchase',
    id: 'appointment.purchase',
  },
  other: {
    defaultMessage: 'Other',
    id: 'appointment.other',
  },
  noAvailableBoutiques: {
    defaultMessage:
      "We're sorry, there is no Breitling store available in your country.",
    id: 'appointment.noAvailableBoutiques',
  },
  storeLocatorToBrowse: {
    defaultMessage:
      'You can use the Breitling Store locator to browse all our stores.',
    id: 'appointment.storeLocatorToBrowse',
  },
  storeLocator: {
    defaultMessage: 'Stores',
    id: 'appointment.storeLocator',
  },
  btqAppointmentPhoneNumberError: {
    defaultMessage: 'This value is not a valid phone number.',
    id: 'btq.appointment.phoneNumberError',
  },
  findAStore: {
    defaultMessage: 'Find a Store',
    id: 'btq.appointment.findAStore',
  },
});
export const KeepInformed = (
  <FormattedMessage
    defaultMessage='I would like to be kept informed by Breitling SA and my preferred Boutique about Breitling offers, events, and other customer engagement activities through email, telephone, SMS, post, and WhatsApp. You can revoke this consent at any time by sending a message to {dataprivacyEmail} or by clicking the "unsubscribe" button in our marketing emails.'
    id='btq.appointment.keepInformed'
    values={{
      dataprivacyEmail: <span>dataprivacy@breitling.com</span>,
    }}
  />
);
export const ConfirmLegal = (
  <FormattedMessage
    defaultMessage='By clicking "Book my appointment", you confirm you have read the {policyLink} and have read and accepted {breitlingTermsOfUse}.'
    id='btq.appointment.confirmLegal'
    values={{
      breitlingTermsOfUse: (
        <LinkWithLocale
          aria-label={getLinkAriaLabel(paths.termsOfUse.url().pathname ?? '')}
          href={paths.termsOfUse.url()}
          target='_blank'
        >
          <FormattedMessage {...termsCommonMessages.breitlingTermsOfUse} />
        </LinkWithLocale>
      ),
      policyLink: (
        <LinkWithLocale
          aria-label={getLinkAriaLabel(
            paths.privacyPolicy.url().pathname ?? '',
          )}
          href={paths.privacyPolicy.url()}
          target='_blank'
        >
          <FormattedMessage {...termsCommonMessages.breitlingPrivacyPolicy} />
        </LinkWithLocale>
      ),
    }}
  />
);
